import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireAuth, RequireOwner } from "@/components/auth/Guards";
import LoginPage from "@/pages/LoginPage";
import LauncherPage from "@/pages/LauncherPage";
import FinancePage from "@/pages/finance/FinancePage";
import InvestmentDetailPage from "@/pages/finance/InvestmentDetailPage";
import LoanDetailPage from "@/pages/finance/LoanDetailPage";
import ConectaLayout from "@/pages/conecta/ConectaLayout";
import RedPage from "@/pages/conecta/RedPage";
import ContactDetailPage from "@/pages/conecta/ContactDetailPage";
import NegociosPage from "@/pages/conecta/NegociosPage";
import OpportunityDetailPage from "@/pages/conecta/OpportunityDetailPage";
import ComisionesPage from "@/pages/conecta/ComisionesPage";
import MasPage from "@/pages/conecta/MasPage";
import GrabarPage from "@/pages/conecta/GrabarPage";
import CaptureCardPage from "@/pages/conecta/CaptureCardPage";
import RevisarPage from "@/pages/conecta/RevisarPage";
import NecesidadesPage from "@/pages/conecta/NecesidadesPage";
import HoyPage from "@/pages/conecta/HoyPage";
import CrucePage from "@/pages/conecta/CrucePage";
import AlertasPage from "@/pages/conecta/AlertasPage";
import ConfigPage from "@/pages/conecta/ConfigPage";
import { startQueue } from "@/lib/captureQueue";
import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";

const QueueStarter = () => {
  const { user } = useAuth();
  useEffect(() => { if (user) startQueue(); }, [user]);
  return null;
};
import PocPage from "@/pages/PocPage";
import AuthCallback from "@/pages/AuthCallback";
import InviteLandingPage from "@/pages/InviteLandingPage";
import InviteSignupPage from "@/pages/InviteSignupPage";
import MiRedPage from "@/pages/conecta/MiRedPage";
import InvitacionesPage from "@/pages/conecta/InvitacionesPage";
import MemberProfilePage from "@/pages/conecta/MemberProfilePage";
import BuscarRedPage from "@/pages/conecta/BuscarRedPage";
import SolicitudesPage from "@/pages/conecta/SolicitudesPage";
import SolicitudDetailPage from "@/pages/conecta/SolicitudDetailPage";
import NotificacionesPage from "@/pages/conecta/NotificacionesPage";
import ActividadPage from "@/pages/conecta/ActividadPage";
import MetricasPage from "@/pages/admin/MetricasPage";
import { PrivacyGate } from "@/components/red/PrivacyGate";

function AppRoutes() {
  const location = useLocation();
  // Process a Google session_id synchronously, before any route renders.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/i/:codigo" element={<InviteLandingPage />} />
      <Route path="/i/:codigo/registro" element={<InviteSignupPage />} />
      <Route path="/" element={<RequireAuth><LauncherPage /></RequireAuth>} />
      <Route path="/inversiones" element={<RequireOwner><FinancePage /></RequireOwner>} />
      <Route path="/inversiones/:id" element={<RequireOwner><InvestmentDetailPage /></RequireOwner>} />
      <Route path="/prestamos/:id" element={<RequireOwner><LoanDetailPage /></RequireOwner>} />
      <Route path="/admin/metricas" element={<RequireAuth><MetricasPage /></RequireAuth>} />
      <Route path="/conecta" element={<RequireAuth><ConectaLayout /></RequireAuth>}>
        <Route index element={<HoyPage />} />
        <Route path="cruce" element={<CrucePage />} />
        <Route path="alertas" element={<AlertasPage />} />
        <Route path="config" element={<ConfigPage />} />
        <Route path="negocios" element={<NegociosPage />} />
        <Route path="negocios/:id" element={<OpportunityDetailPage />} />
        <Route path="grabar" element={<GrabarPage />} />
        <Route path="capturas/:id" element={<CaptureCardPage />} />
        <Route path="revisar" element={<RevisarPage />} />
        <Route path="necesidades" element={<NecesidadesPage />} />
        <Route path="red" element={<RedPage />} />
        <Route path="red/:id" element={<ContactDetailPage />} />
        <Route path="comisiones" element={<ComisionesPage />} />
        <Route path="mas" element={<MasPage />} />
        <Route path="mi-red" element={<PrivacyGate><MiRedPage /></PrivacyGate>} />
        <Route path="invitaciones" element={<InvitacionesPage />} />
        <Route path="u/:id" element={<MemberProfilePage />} />
        <Route path="buscar" element={<PrivacyGate><BuscarRedPage /></PrivacyGate>} />
        <Route path="actividad" element={<ActividadPage />} />
        <Route path="solicitudes" element={<SolicitudesPage />} />
        <Route path="solicitudes/:id" element={<SolicitudDetailPage />} />
        <Route path="avisos" element={<NotificacionesPage />} />
      </Route>
      <Route path="/poc" element={<RequireOwner><PocPage /></RequireOwner>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <QueueStarter />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
